import type { ReportPayment, ReportPaymentFormKit } from "./reportPayment";

export default {
  addAuthRequestFields,
  skinnyResponseAdapter,
  responseAdapter,
  getInitialData,
  toFormkit,
  fromFormkit,
};

function addAuthRequestFields(entity: ReportPayment) {
  entity._authRequestFields = ["id", "reportId"] as (keyof ReportPayment)[];
  return entity;
}

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: ReportPayment }) {
  addAuthRequestFields(response.data);
  return response.data;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: ReportPayment }) {
  await skinnyResponseAdapter(response);

  return response.data;
}

function getInitialData() {
  const result = {} as ReportPayment;
  return addAuthRequestFields(result);
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit(data: ReportPayment) {}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: ReportPaymentFormKit) {}
